import { isClientError } from './NetworkErrorClasses';

export type MaxLimitErrorResponse = {
  errorCode: number | string;
  message: string;
  title: string;
};

export type ClientErrorResponse = {
  errorCode: number | string;
  message: string;
  title?: string;
};

const isPrimitiveErrorCode = (value: unknown): value is number | string =>
  typeof value === 'number' || typeof value === 'string';

export const getClientErrorResponse = (
  error: unknown,
  expectedErrorCode: number | string,
): ClientErrorResponse | undefined => {
  const responseBody = isClientError(error) ? error.responseBody : undefined;

  if (!responseBody || typeof responseBody !== 'object') {
    return undefined;
  }

  const { errorCode, message, title } = responseBody as {
    errorCode?: unknown;
    message?: unknown;
    title?: unknown;
  };

  if (
    !isPrimitiveErrorCode(errorCode) ||
    !isPrimitiveErrorCode(expectedErrorCode) ||
    String(errorCode) !== String(expectedErrorCode) ||
    typeof message !== 'string' ||
    message.trim().length === 0
  ) {
    return undefined;
  }

  return {
    errorCode,
    message,
    title:
      typeof title === 'string' && title.trim().length > 0 ? title : undefined,
  };
};

export const getMaxLimitErrorResponse = (
  error: unknown,
): MaxLimitErrorResponse | undefined => {
  const response = getClientErrorResponse(error, 4);

  if (!response || !response.title) {
    return undefined;
  }

  return {
    errorCode: response.errorCode,
    message: response.message,
    title: response.title,
  };
};
